<div class="iching-consult" [class.iching-consult--embedded]="embedded()">
  @if (!embedded()) {
  <header class="iching-consult__header">
    <div class="iching-consult__heading">
      <h2 class="iching-consult__title">{{ t('humanDesign.iching.page.title') }}</h2>
      <e-segmented-toggle testId="iching-view" [options]="viewOptions()" [value]="view()" (valueChange)="setView($event)" />
    </div>
    <div class="iching-consult__actions">
      <button
        type="button"
        class="iching-consult__icon-btn"
        data-test-id="iching-guide"
        [disabled]="!method()"
        [attr.aria-label]="t('humanDesign.iching.consult.guide')"
        [title]="t('humanDesign.iching.consult.guide')"
        (click)="openGuide($event)"
      >
        <i class="fas fa-circle-question" aria-hidden="true"></i>
      </button>
      <e-hd-content-language-picker></e-hd-content-language-picker>
      <button type="button" class="iching-consult__new" data-test-id="iching-new" (click)="newConsultation()">
        {{ t('humanDesign.iching.consult.newConsultation') }}
      </button>
    </div>
  </header>
  }

  @if (view() === 'journal') {
    <hd-iching-journal-list
      [refreshToken]="session.journalRefresh()"
      (consultationSelected)="reopen($event)"
      (consultationDeleted)="consultationDeleted($event)"
    />
  } @else {
    @if (method(); as m) {
      @if (!embedded()) {
        <hd-iching-intro [intro]="m.steps.intro" [collapsed]="introCollapsed()" (collapsedChange)="setIntroCollapsed($event)" />
      }

      <section class="iching-consult__phase" data-phase="1" [class.iching-consult__phase--summary]="!!reading()">
        <h3 class="iching-consult__phase-title">{{ t('humanDesign.iching.consult.phase1') }}</h3>
        @if (stepById('question'); as step) {
          <hd-iching-step-help [step]="step" />
          <hd-iching-question-step
            [step]="step"
            [question]="draft().question"
            [questionKind]="draft().questionKind"
            (questionChange)="setQuestion($event)"
            (questionKindChange)="setQuestionKind($event)"
          />
        }
      </section>

      <section class="iching-consult__phase" data-phase="2" [class.iching-consult__phase--summary]="!!reading()">
        <h3 class="iching-consult__phase-title">{{ t('humanDesign.iching.consult.phase2') }}</h3>
        @if (stepById('cast'); as step) {
          <hd-iching-step-help [step]="step" />
          <hd-iching-cast-step
            [mode]="castMode()"
            [distribution]="distribution()"
            [lines]="draft().lines"
            [manualDraft]="draft().manualLines"
            [coinFaces]="draft().coinFaces"
            [legend]="step.legend"
            [compact]="!!reading()"
            (linesChange)="setLines($event)"
            (manualDraftChange)="setManualLines($event)"
            (coinFacesChange)="addCoinFaces($event)"
            (modeChange)="setCastMode($event)"
            (distributionChange)="setDistribution($event)"
          />
        }
      </section>

      @if (reading(); as r) {
        <section class="iching-consult__phase" data-phase="3">
          <h3 class="iching-consult__phase-title">{{ t('humanDesign.iching.consult.phase3') }}</h3>

          <!-- Contextkaart: voor welke chart en op welk tijdstip deze raadpleging gaat, met de
               planeetstanden van dat moment. Het tijdstip is bewerkbaar tot de raadpleging bewaard
               is; daarna pas weer na "Tijdstip aanpassen". -->
          <div class="iching-consult__context" data-test-id="iching-context">
            <div class="iching-consult__context-row">
              @if (contextChartName(); as chartName) {
                <span class="iching-consult__context-chart" data-test-id="iching-context-chart">
                  <i class="fas fa-user" aria-hidden="true"></i> {{ chartName }}
                </span>
              }
              <label class="iching-consult__context-when">
                <span>{{ t('humanDesign.iching.moment.consultedAt') }}</span>
                <input
                  type="datetime-local"
                  class="iching-consult__context-input"
                  data-test-id="iching-consulted-at"
                  [value]="consultedAtLocal()"
                  [disabled]="!timeEditable()"
                  (change)="setConsultedAt($any($event.target).value)"
                />
              </label>
              @if (!timeEditable()) {
                <button type="button" class="iching-consult__context-edit" data-test-id="iching-edit-time" (click)="enableTimeEdit()">
                  {{ t('humanDesign.iching.moment.editTime') }}
                </button>
              }
            </div>
            @if (draft().consultedAt; as consultedAt) {
              <hd-iching-transit-block [atUtc]="consultedAt" />
            }
          </div>

          <hd-iching-reading
            [reading]="r"
            [method]="m"
            [hexagram]="readingContent.hexagram()"
            [changedHexagram]="readingContent.changedHexagram()"
            [nuclearEntry]="readingContent.nuclearEntry()"
            [commentary]="readingContent.commentary()"
            [commentaryBusy]="readingContent.commentaryBusy()"
            [trigramNames]="readingContent.trigramNames()"
            [coinFaces]="draft().coinFaces"
            [relationMode]="draft().relationMode"
            [nameRevealed]="draft().nameRevealed"
            [keywords]="draft().keywords"
            [notes]="draft().notes"
            [doList]="draft().doList"
            [dontList]="draft().dontList"
            [saving]="session.saving()"
            [saved]="session.saved()"
            [canRevisit]="session.savedId() !== undefined"
            (relationModeChange)="updateDraft({ relationMode: $event })"
            (nameRevealedChange)="updateDraft({ nameRevealed: $event })"
            (keywordsChange)="updateDraft({ keywords: $event })"
            (notesChange)="updateDraft({ notes: $event })"
            (doListChange)="updateDraft({ doList: $event })"
            (dontListChange)="updateDraft({ dontList: $event })"
            (commentaryRequested)="loadCommentary()"
            (save)="save()"
            (copy)="copy()"
            (revisitRequested)="revisit()"
            (openHexagram)="openHexagram($event)"
          />
        </section>
      }

      @if (!embedded() && m.terms.length > 0) {
        <details class="iching-consult__glossary" data-test-id="iching-glossary">
          <summary class="iching-consult__glossary-title">{{ t('humanDesign.iching.consult.allTerms') }}</summary>
          <dl class="iching-consult__glossary-list">
            @for (term of m.terms; track term.id) {
              <div class="iching-consult__glossary-term">
                <dt>{{ term.term }}</dt>
                <dd>{{ term.long }}</dd>
              </div>
            }
          </dl>
        </details>
      }
    } @else if (methodError()) {
      <div class="iching-consult__state" role="alert">
        <p>{{ t('humanDesign.iching.panel.loadError') }}</p>
        <button type="button" class="iching-consult__new" (click)="retryMethod()">{{ t('humanDesign.iching.panel.retry') }}</button>
      </div>
    } @else {
      <div class="iching-consult__state" role="status">
        <e-splash-loader [size]="40" />
      </div>
    }
  }
</div>
